export const Permissions = {
    customer: {
        read: "cust_view",
        write: "cust_write",
        bulk: "cust_bulk",
        delete: "cust_delete",
        customFields: {
            read: "cust_view",
            update: "cust_write",
        },
        label: {
            read: "cust_view",
            update: "cust_write",
        },
        import: {
            create: "cust_bulk",
            read: "cust_bulk",
            allTemplate: {
                read: "cust_bulk",
            },
        },
        export: {
            create: "export_view",
        },
        bulkDelete: {
            delete: "cust_bulk",
        },
        sameAs: {
            read: "cust_view",
            write: "cust_write",
        },
        relatedCustomer: {
            index: {
                read: "cust_view",
                create: "cust_write",
            },
        },
        commentsAndAttachments: {
            read: "cust_view",
            update: "cust_write",
        },
    },
    pendingCertificate: {
        view: "cert_in_view",
        write: "cert_in_write",
        complete: "cert_in_complete",
        delete: "cert_in_delete",
    },
    certificate: {
        read: "cert_view",
        create: "cert_write",
        update: "cert_write",
        delete: "cert_delete",
        file: {
            create: "cert_write",
            update: "cert_write",
            delete: "cert_delete",
            read: "cert_view",
        },
        splitFile: {
            create: "cert_write",
        },
        assignRelease: {
            update: "cert_in_complete",
        },
        customFields: {
            read: "cert_view",
            create: "cert_write",
            update: "cert_write",
            delete: "cert_write",
        },
        label: {
            read: "cert_view",
            update: "cert_write",
        },
        pauseResume: {
            update: "cert_write",
            read: "cert_view",
        },
        export: {
            create: "export_view",
        },
        bulkDelete: {
            delete: "cert_bulk",
        },
        bulkEdit: {
            labels: {
                update: "cert_bulk",
            },
            expirationDate: {
                update: "cert_bulk",
            },
            invalidReasons: {
                update: "cert_bulk",
            },
        },
        history: {
            read: "cert_view",
        },
        resync: {
            index: "cert_bulk",
        },
        bulkUpload: {
            create: "cert_bulk",
            read: "cert_bulk",
        },
        reviewer: {
            read: "cert_view",
        },
        bulkPrint: {
            index: "export_view",
        },
        emailNotification: {
            update: "cert_write",
            read: "cert_view",
            create: "cert_write",
            delete: "cert_write",
        },
        comment: {
            read: "cert_view",
            create: "cert_write",
            update: "cert_write",
            delete: "cert_write",
        },
    },
    coverLetter: {
        index: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        outgoing: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
    },
    settings: {
        index: {
            generalRead: "settings_view",
            generalUpdate: "settings_write",
            certificateRequestSettingsRead: "settings_view",
            certificateRequestSettingsUpdate: "settings_write",
        },
        customerCustomFields: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        vendorCustomFields: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        customerCertificateCustomFields: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        vendorCertificateCustomFields: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        customerLabel: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        certificateLabel: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        companyGroups: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        region: {
            create: "settings_write",
            read: "settings_view",
            update: "settings_write",
            delete: "settings_write",
        },
        exemptProductCategories: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
        certificateExemptionForm: {
            incoming: {
                read: "settings_view",
                update: "settings_write",
                delete: "settings_write",
                create: "settings_write",
            },
            outgoing: {
                read: "settings_view",
                create: "settings_write",
                update: "settings_write",
                delete: "settings_write",
            },
        },
        certificateRequestOption: {
            read: "settings_view",
            update: "settings_write",
        },
        userPreferences: {
            update: "pref_write",
        },
    },
    taxContent: {
        index: {
            read: "tax_content_read",
        },
    },
    certificateRequests: {
        index: {
            read: "cert_req_view",
            create: "cert_req_write",
        },
        singleRequest: {
            read: "cert_req_view",
            create: "cert_req_write",
        },
    },
    retailSettings: {
        index: {
            read: "settings_view",
            update: "settings_write",
        },
        location: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
    },
    exemptionReasons: {
        index: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
    },
    invalidReasons: {
        index: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
    },
    accountSignature: {
        index: {
            read: "settings_view",
            create: "settings_write",
            update: "settings_write",
            delete: "settings_write",
        },
    },
    vendor: {
        index: {
            read: "cust_view",
            create: "cust_write",
            update: "cust_write",
            delete: "cust_write",
        },
        certificate: {
            read: "cert_view",
            create: "cert_write",
            update: "cert_write",
            delete: "cert_write",
        },
        additionalInfo: {
            read: "cust_view",
            update: "cust_write",
        },
        import: {
            create: "cust_bulk",
            read: "cust_bulk",
        },
        export: {
            create: "export_view",
        },
        packages: {
            read: "cust_view",
            create: "cust_write",
            update: "cust_write",
            delete: "cust_write",
        },
        bulkDelete: {
            delete: "cust_bulk",
            read: "cust_bulk",
        },
        history: {
            read: "cust_view",
        },
        customFields: {
            read: "cust_view",
            update: "cust_write",
        },
        customLabels: {
            read: "cust_view",
            update: "cust_write",
        },
        importCertificateTemplate: {
            read: "cust_bulk",
        },
    },
    retail: {
        index: {
            read: "ret_view",
            create: "ret_write",
            update: "ret_write",
            delete: "ret_write",
        },
    },
    savedSearch: {
        index: {
            read: "report_cert_view",
            create: "report_cert_view",
            update: "report_cert_view",
            delete: "report_cert_view",
        },
    },
    adminReports: {
        index: {
            read: "report_admin_view",
        },
    },
    userRoleManagement: { manage: "user_manage" },
    export: {
        read: "export_view",
    },
} as const;

export const retailPermissionsTag = "retail_";

// Helper type to extract all string values from a nested object
type ExtractValues<T> = T extends string
    ? T
    : T extends Record<string, unknown>
      ? { [K in keyof T]: ExtractValues<T[K]> }[keyof T]
      : never;

// Type representing an array of all permission values from the Permissions object
export type PermissionValues = ExtractValues<typeof Permissions>[];
